import { render, staticRenderFns } from "./newLabel.vue?vue&type=template&id=3b51b8ba"
import script from "./newLabel.vue?vue&type=script&lang=js"
export * from "./newLabel.vue?vue&type=script&lang=js"
import style0 from "./newLabel.vue?vue&type=style&index=0&id=3b51b8ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports